import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CommonSearchBox from "../SearchBox/CommomSearchBox";
import ConfirmBox from "../Popup/ConfirmBox";
import EmptyScreen from "../common/EmptyScreen";
import { fetchBanner, deleteBanner, openGlobalPopup, updateBannerStatus, editBanner, closeGlobalPopup} from '../../redux/action';
import "./BannerList.css"; 
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";

function BannerList({ onEdit }) {
  const { t } = useTranslation();
  const [deleteId, setDeleteId] = useState('');
  const [validationError, setValidationError] = useState('');
  
  // Select both banners and current open modal type from Redux
  const bannersObj = useSelector((state) => state.admin?.banners) || [];
  const globalPopupKey = useSelector((state) => state.admin?.globalPopupKey);
  const banners = Array.isArray(bannersObj) ? bannersObj : Object.values(bannersObj);
  
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(fetchBanner());
  }, [dispatch]);

  const filteredBanners = banners.filter((banner) =>
    banner.bannerName.toLowerCase().includes(search.toLowerCase())
  );

  const activeCount = banners.filter(b => b.displayOnMenu).length;

  const handleToggleStatus = (banner) => {
    if (!banner.displayOnMenu && activeCount >= 4) {
      setValidationError("Maximum 4 active banners allowed on QR Portal!");
      return;
    }
    setValidationError('');
    dispatch(updateBannerStatus({
      bannerId: banner.bannerId,
      displayOnMenu: !banner.displayOnMenu,
      previousDisplayOnMenu: banner.displayOnMenu,
    }));
  };

// Inside BannerList.jsx
const handleDelete = (banner) => {
  // 🚀 Fallback to 'id' if 'bannerId' does not exist yet for this fresh item
  const actualId = banner.bannerId || banner.id; 
  setDeleteId(actualId);
  dispatch(openGlobalPopup("confirm-box"));
};

  const handleEdit = (banner) => {
    dispatch(editBanner(banner));
    onEdit();
  };

  return (
    <div className="table-container">

         <div className="banner-header-flex-wrapper">
            <h3 className="banner-main-title" style={{ padding: "0px 0px 0px 10px" }}>{t("Banners")} ({filteredBanners.length})</h3>
            <span className={`banner-live-status-badge ${activeCount === 4 ? "limit-reached" : ""}`}>
              {t("Live on QR")}: {activeCount}
            </span>
          </div>

          {validationError && <p className="banner-validation-error-msg">{validationError}</p>}

          <CommonSearchBox
            placeholder="Search banner by name..."
            search={search}
            setSearch={setSearch}
          />

      {filteredBanners.length === 0 ? (
        <EmptyScreen message="No banners found. Please upload a promotional banner." />
      ) : (
        <>
       
          
          <div className="table-wrapper">
            <table className="table">
              <thead>
                <tr>
                  <th>Display Status</th>
                  <th>Preview</th>
                  <th>Banner Name</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredBanners.map((banner) => (
                  <tr key={banner.bannerId} className={banner.displayOnMenu ? "active-row-highlight" : ""}>
                    <td>
                      <label className="banner-status-checkbox-label">
                        <input
                          type="checkbox"
                          checked={banner.displayOnMenu}
                          onChange={() => handleToggleStatus(banner)}
                          className="banner-native-checkbox"
                        />
                        <span className={banner.displayOnMenu ? "text-live" : "text-hidden"}>
                          {banner.displayOnMenu ? t("Live") : t("Hidden")}
                        </span>
                      </label>
                    </td>
                    <td>
                      <img 
                        src={banner.bannerImage} 
                        alt={banner.bannerName} 
                        className="banner-table-preview-img"
                      />
                    </td>
                    <td className="banner-name-cell-text">{banner.bannerName}</td>
                    <td>
                      <span className="edit-icon link-btn" title="Edit" aria-label="Edit" onClick={() => handleEdit(banner)}>✎</span>
                      <span className="delete-icon link-btn danger" title="Delete" onClick={() => handleDelete(banner)}>✖</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table> 
          </div>
        </>
      )}

      {/* Only display the Confirm Delete modal markup if Redux actively requests it */}
     
        <ConfirmBox
          variant="delete"
          title={"Are you sure you want to delete this promotional banner?"}
          closeOnConfirm={true}
          onConfirm={() => {
            if (deleteId) {
              dispatch(deleteBanner(deleteId));
            }
          }}
          onCancel={() => {
            dispatch(closeGlobalPopup());
            setDeleteId('');
          }} 
        />
      
    </div>
  );
}

export default BannerList;
